import { render } from "./NoLongerGiving.vue?vue&type=template&id=3c4e2a93&scoped=true"
import script from "./NoLongerGiving.vue?vue&type=script&lang=js"
export * from "./NoLongerGiving.vue?vue&type=script&lang=js"

import "./NoLongerGiving.vue?vue&type=style&index=0&id=3c4e2a93&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4e2a93"]])

export default __exports__